export default {
  root: {
    justifyContent: 'center'
  }
}